import { TFunction } from "i18next";

import { ActionIntervalType } from "../@types/Protocol";

/**
 * EN-5283: the label for an action interval, keyed on the API's ActionIntervalType.
 *
 * The API sends interval names in English: `IntervalName` in the frequency dropdown, and
 * `frequency` ("Every 6 months") on a patient's protocol actions. Neither can be translated
 * server-side, because `IntervalName` is also how the API looks intervals up
 * (`FindByIntervalNameAsync`). The `type` that comes with both is stable, so the label is built
 * here instead.
 */
const FREQUENCY_LABEL_KEYS: Record<ActionIntervalType, string> = {
  OnceOff: "protocols_frequency_onceOff",
  Daily: "protocols_frequency_daily",
  Weekly: "protocols_frequency_weekly",
  Monthly: "protocols_frequency_monthly",
  Yearly: "protocols_frequency_yearly",
  EveryXHours: "protocols_frequency_everyXHours",
  EveryXDays: "protocols_frequency_everyXDays",
  EveryXWeeks: "protocols_frequency_everyXWeeks",
  EveryXMonths: "protocols_frequency_everyXMonths",
  EveryXYears: "protocols_frequency_everyXYears",
  PinToAppHomeScreen: "protocols_frequency_pinToAppHomeScreen",
};

/**
 * The translated label for an interval. `iterations` fills the "every N" intervals: the
 * builder passes "X" (the count is chosen in a separate field), a patient's action passes its
 * count. A type this list does not know gets `fallback`, the API's English name.
 */
export function formatActionFrequency(
  t: TFunction,
  type: string | undefined,
  iterations: number | string,
  fallback: string
): string {
  if (
    !type ||
    !Object.prototype.hasOwnProperty.call(FREQUENCY_LABEL_KEYS, type)
  )
    return fallback;

  return t(FREQUENCY_LABEL_KEYS[type as ActionIntervalType], { iterations });
}
